
import {defineComponent, PropType} from "vue";
import {MenuItem} from "./MenuItem";

export default defineComponent({
  props: {
    isOpen: {
      required: true,
      type: Boolean,
    },
    items: {
      type: Array as PropType<MenuItem[]>,
      default: [],
    },
    userAlreadyToggle: {
      required: true,
      type: Boolean,
    },
  },
});
